"use client";
import { useEffect } from "react";

const Preconnect = () => {
  useEffect(() => {
    // Add preconnect hints for critical domains
    const domains = [
      "https://clerk.bundled.design",
      "https://api.bundled.design",
      "https://res.cloudinary.com",
      "https://www.google-analytics.com",
      "https://www.googletagmanager.com",
      "https://www.google.com",
      "https://www.gstatic.com",
      "https://www.googleadservices.com",
      "https://pagead2.googlesyndication.com",
      "https://www.clarity.ms",
      // "https://widget.intercom.io",
    ];

    domains.forEach((domain) => {
      const link = document.createElement("link");
      link.rel = "preconnect";
      link.href = domain;
      link.crossOrigin = "anonymous";
      document.head.appendChild(link);

      // Also add dns-prefetch for better performance
      const dnsLink = document.createElement("link");
      dnsLink.rel = "dns-prefetch";
      dnsLink.href = domain;
      document.head.appendChild(dnsLink);
    });

    // Cleanup function
    return () => {
      const links = document.querySelectorAll(
        'link[rel="preconnect"], link[rel="dns-prefetch"]'
      );
      links.forEach((link) => link.remove());
    };
  }, []);

  return null;
};

export default Preconnect;
